module.exports = __webpack_public_path__ + "history.png?a97d547277949c9c8d6790c9b4628c4d";


//////////////////
// WEBPACK FOOTER
// ./static/images/history.png
// module id = 380
// module chunks = 0